var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _taggedTemplateLiteral = require("/workspace/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pageResults = require('graph-results-pager');

var _require = require('graphql-request'),
    request = _require.request,
    gql = _require.gql;

var blocklytics = 'https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks';

var _require2 = require("date-fns"),
    getUnixTime = _require2.getUnixTime,
    startOfHour = _require2.startOfHour,
    startOfMinute = _require2.startOfMinute,
    startOfSecond = _require2.startOfSecond,
    subHours = _require2.subHours;

function timestampToBlock(_x) {
  return _timestampToBlock.apply(this, arguments);
}

function _timestampToBlock() {
  _timestampToBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(timestamp) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timestamp = String(timestamp).length > 10 ? Math.floor(timestamp / 1000) : timestamp;
            _context.next = 3;
            return request(blocklytics, gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n            blocks(first: 1, orderBy: timestamp, orderDirection: desc, where: { timestamp_lte: ", " }) {\n                number\n            }\n        }"])), timestamp));

          case 3:
            result = _context.sent;
            return _context.abrupt("return", Number(result.blocks[0].number));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _timestampToBlock.apply(this, arguments);
}

function timestampsToBlocks(_x2) {
  return _timestampsToBlocks.apply(this, arguments);
}

function _timestampsToBlocks() {
  _timestampsToBlocks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(timestamps) {
    var query, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{\n            ", "\n        }"])), timestamps.map(function (timestamp) {
              return gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                timestamp", ": blocks(first:1, orderBy: timestamp, orderDirection: desc, where: { timestamp_lte: ", "}) {\n                    number\n            }"])), timestamp, timestamp);
            }));
            _context2.next = 3;
            return request(blocklytics, query);

          case 3:
            result = _context2.sent;
            result = Object.keys(result).map(function (key) {
              return _objectSpread(_objectSpread({}, result[key]), {}, {
                timestamp: key.split("timestamp")[1]
              });
            }).sort(function (a, b) {
              return Number(a.timestamp) - b.timestamp;
            });
            result.forEach(function (e) {
              return delete e.timestamp;
            });
            return _context2.abrupt("return", result = Object.values(result).map(function (e) {
              return Number(e[0].number);
            }));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _timestampsToBlocks.apply(this, arguments);
}

function blockToTimestamp(_x3) {
  return _blockToTimestamp.apply(this, arguments);
}

function _blockToTimestamp() {
  _blockToTimestamp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(block) {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return request(blocklytics, gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["{\n            blocks(first: 1, where: { number: ", " }) {\n                timestamp\n            }\n        }"])), block));

          case 2:
            result = _context3.sent;
            return _context3.abrupt("return", Number(result.blocks[0].timestamp));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _blockToTimestamp.apply(this, arguments);
}

function getAverageBlockTime() {
  return _getAverageBlockTime.apply(this, arguments);
}

function _getAverageBlockTime() {
  _getAverageBlockTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _ref,
        _ref$block,
        block,
        _ref$timestamp,
        timestamp,
        now,
        start,
        end,
        blocks,
        averageBlockTime,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, _ref$block = _ref.block, block = _ref$block === void 0 ? undefined : _ref$block, _ref$timestamp = _ref.timestamp, timestamp = _ref$timestamp === void 0 ? undefined : _ref$timestamp;
            timestamp = timestamp ? String(timestamp).length > 10 ? Math.floor(timestamp / 1000) : timestamp : undefined;

            if (!timestamp) {
              _context4.next = 6;
              break;
            }

            _context4.t0 = timestamp;
            _context4.next = 14;
            break;

          case 6:
            if (!block) {
              _context4.next = 12;
              break;
            }

            _context4.next = 9;
            return blockToTimestamp(block);

          case 9:
            _context4.t1 = _context4.sent;
            _context4.next = 13;
            break;

          case 12:
            _context4.t1 = undefined;

          case 13:
            _context4.t0 = _context4.t1;

          case 14:
            timestamp = _context4.t0;
            now = startOfSecond(startOfMinute(startOfHour(timestamp ? timestamp * 1000 : Date.now())));
            start = getUnixTime(subHours(now, 6));
            end = getUnixTime(now);
            _context4.next = 20;
            return pageResults({
              api: blocklytics,
              query: {
                entity: 'blocks',
                selection: {
                  orderBy: "number",
                  orderDirection: "desc",
                  where: {
                    timestamp_gte: start,
                    timestamp_lte: end
                  }
                },
                properties: ['timestamp']
              }
            });

          case 20:
            blocks = _context4.sent;
            averageBlockTime = blocks.sort(function (a, b) {
              return Number(b.timestamp) - Number(a.timestamp);
            }).reduce(function (previousValue, currentValue, currentIndex) {
              if (previousValue.timestamp) {
                var difference = previousValue.timestamp - currentValue.timestamp;
                previousValue.difference = previousValue.difference + difference;
              }

              previousValue.timestamp = currentValue.timestamp;

              if (currentIndex === blocks.length - 1) {
                return previousValue.difference / blocks.length;
              }

              return previousValue;
            }, {
              timestamp: null,
              difference: 0
            });
            return _context4.abrupt("return", averageBlockTime);

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getAverageBlockTime.apply(this, arguments);
}

module.exports = {
  timestampToBlock: timestampToBlock,
  timestampsToBlocks: timestampsToBlocks,
  blockToTimestamp: blockToTimestamp,
  getAverageBlockTime: getAverageBlockTime
};